module.exports = __webpack_public_path__ + "static/media/ycombinator.d8e47780.svg";